export default "__VITE_ASSET__Dr25ftV8__"